import CategoryForm from '../../components/Forms/CategoryForm';
import { invalidUrlError, validateUrl } from '../../utils/functions';

const PersonForm = ({ functionality }) => {
  const fields = [
    { name: 'name', label: 'Name', type: 'text', required: true },
    { name: 'title', label: 'Title/Position', type: 'text', required: true },
    {
      name: 'type',
      label: 'Type of Person',
      type: 'text',
      required: true,
      drop_down: true,
      options: [
        {
          value: 'Academic / Ph.D Candidate or Student',
          label: 'Academic / Ph.D Candidate or Student',
        },
        { value: 'Innovator', label: 'Innovator' },
        { value: 'Financier', label: 'Financier' },
        { value: 'Strategic Corporate', label: 'Strategic Corporate' },
        { value: 'Government/NGO', label: 'Government/NGO' },
        { value: 'Philanthropic', label: 'Philanthropic' },
        { value: 'Consultant', label: 'Consultant' },
        { value: 'Journalist', label: 'Journalist' },
        { value: 'Other', label: 'Other' },
      ],
    },
    { name: 'expertise', label: 'Expertise/Fields of Interest', type: 'text', required: true },
    { name: 'affiliations', label: 'Organization/Affiliation', type: 'text', required: true },
    {
      name: 'organization_url',
      label: 'Organization URL',
      type: 'text',
      placeholder: 'https://google.com/',
      pattern: validateUrl,
      title: invalidUrlError,
      required: true,
    },
    { name: 'department', label: 'Department', type: 'text' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'rob.jackson@stanford.edu' },
    {
      name: 'homepage',
      label: 'Personal Website',
      type: 'text',
      placeholder: 'https://profiles.stanford.edu/jackson',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'LinkedIn',
      label: 'LinkedIn',
      type: 'text',
      placeholder: 'https://www.linkedin.com/in/rob-jackson/',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'ResearchGate',
      label: 'ResearchGate',
      type: 'text',
      placeholder: 'https://www.researchgate.net/profile/Robert-Jackson-14',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'GoogleScholar',
      label: 'Google Scholar',
      type: 'text',
      placeholder: 'https://scholar.google.com/citations?user=G3NBUzwAAAAJ&hl=en',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'ORCID',
      label: 'ORCID',
      type: 'text',
      placeholder: 'https://orcid.org/0000-0001-8846-7147',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'BlueSky',
      label: 'BlueSky',
      type: 'text',
      placeholder: 'https://bsky.app/profile/mcuban.bsky.social',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    { name: 'about', label: 'About', type: 'text', text_area: true },
    {
      name: 'education',
      label: 'Educational Background',
      type: 'text',
      text_area: true,
      placeholder: 'Highest degree, field of study, graduating institution',
    },
    {
      name: 'professional_experience',
      label: 'Professional Background',
      type: 'text',
      text_area: true,
    },
    {
      name: 'resume',
      label: 'CV/Resume',
      type: 'text',
      placeholder: 'https://cap.stanford.edu/profiles/viewCV?facultyId=48949&name=Rob_Jackson',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    { name: 'image_url', label: 'Image', type: 'image' },
  ];
  return (
    <CategoryForm category={'person'} fields={fields} functionality={functionality} tab="Others" />
  );
};
export default PersonForm;
